import { DoconTheme, doconThemeByName, generateThemeWithDsaConfig } from '@docon/docon-ui-library';

const dsaTheme: DoconTheme = doconThemeByName.doconDsa;
const appTheme = generateThemeWithDsaConfig({
  name: 'Qsr lab',
  colorsConfig: {
    primary: ['#10847e', dsaTheme.colors.primaryColor],
  },
});

const borderColor = appTheme.borderColor;
const bgColor = appTheme.bgColor;
const colors = appTheme.colors;

console.log('object appTheme', appTheme);
export {
  colors,
  bgColor,
  borderColor,
  appTheme,
};
